import { useQuery } from 'react-query'
import request from '../request'
import { Dealership } from '../../lib/types/Dealership'

export const useGetDealershipById = (id?: string) => {
  return useQuery(
    ['admin', 'dealership', id],
    ({ signal }) =>
      request<{ data: Dealership }>({
        url: `/admin/dealerships/${id}`,
        method: 'GET',
        signal,
      }).then((res) => res.data),
    {
      enabled: !!id,
    },
  )
}
